import { render } from "./B2bNewUserExistData.vue?vue&type=template&id=a61a5c2a&scoped=true&lang=pug"
import script from "./B2bNewUserExistData.vue?vue&type=script&lang=js"
export * from "./B2bNewUserExistData.vue?vue&type=script&lang=js"

import "./B2bNewUserExistData.vue?vue&type=style&index=0&id=a61a5c2a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61a5c2a"]])

export default __exports__